import { Arrow, ArrowProps } from '../Arrow';
import styled, { css } from 'styled-components';
import { Item } from '../List';

export const SubServicesWrapper = styled.div`
  background: #fff;
  bottom: -1px;
  overflow: auto;
  position: absolute;
  top: -1px;
  z-index: 2;
  width: 100%;
`;

export const skeleton = css`
  background-color: #ccc;
  display: inline-block;
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 1;

  &::after {
    animation: shimmer 3s infinite;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0)
    );
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    transform: translateX(-100%);
    top: 0;
    z-index: 2;
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`;

export const SubServicesPlaceholderWrapper = styled.div`
  display: block;
  width: 100%;
`;

export const SubServicesItem = styled(Item)`
  background: transparent;
  font-size: ${({ theme }) => theme.typography.size.small};
  margin-right: 0;
  padding: ${({ theme }) => `${theme.spacing.base.sm} ${theme.spacing.base.xs}`};
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SubServicesText = styled.span`
  font-size: ${({ theme }) => theme.typography.size.small};
`;

export const SubServicesPlaceholderText = styled.span`
  ${skeleton}
  height: 18px;
  width: 150px;
`;

export const SubServicesDetailsButton = styled.button`
  background: transparent;
  border: 0;
  cursor: pointer;
  margin-left: auto;
  padding: 0;
  outline: none;

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

export const SubServicesDetails = styled.span`
  color: ${({ theme }) => theme.color.primary.default};
  font-size: ${({ theme }) => theme.typography.size.small};
`;

export const SubServicesPlaceholderDetails = styled.span`
  ${skeleton}
  background-color: ${({ theme }) => theme.color.primary.default};
  content: '';
  display: flex;
  height: 16px;
  margin-left: auto;
  opacity: 0.5;
  width: 60px;
`;

export const SubServiceArrow = styled(Arrow)`
  border-color: ${({ theme }) => theme.color.primary.default};
  margin-bottom: 2px;
`;

export const SubServiceDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

export const SubServiceDetailHeader = styled.header`
  border-bottom: solid 1px ${({ theme }) => theme.typography.color.tertiary};
  padding: ${({ theme }) => `${theme.spacing.base.xxs} ${theme.spacing.base.md}`};
`;

export const SubServiceDetailContentWrapper = styled.div`
  border: solid 1px ${({ theme }) => theme.typography.color.tertiary};
  border-radius: 4px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  margin: ${({ theme }) => `0 ${theme.spacing.base.xl} ${theme.spacing.base.md}`};
`;

export const SubServiceDetailContent = styled.div`
  border-top: 0;
  padding: ${({ theme }) => theme.spacing.base.md};
`;

export const SubServiceDetailNav = styled.nav`
  background: #fff;
  margin: 0;
  padding: ${({ theme }) => `${theme.spacing.base.lg} ${theme.spacing.base.xl} 0`};
  position: sticky;
  top: 0;
  width: 100%;
`;

export const SubServiceDetailBackButton = styled.button`
  background: transparent;
  border: 0;
  margin-bottom: ${({ theme }) => theme.spacing.base.md};
  outline: none;

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

export const SubServiceDetailBackArrow = styled(Arrow)<ArrowProps>`
  border-color: rgb(48, 48, 48);
  margin: ${({ theme }) => `0 ${theme.spacing.base.xs} 2px 0`};
`;

export const SubServiceDetailTitle = styled.div`
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  font-size: ${({ theme }) => theme.typography.size.medium};
`;

interface SubServiceInfoProps {
  showBullet: boolean;
}

export const SubServiceInfo = styled.div<SubServiceInfoProps>`
  font-size: ${({ theme }) => theme.typography.size.small};
  display: block;
  margin-top: ${({ theme }) => theme.spacing.base.xxs};
  opacity: 0.8;
  width: 100%;

  ${({ showBullet }) => {
    if (showBullet) {
      return css`
        &::before {
          background-color: rgb(222, 222, 222);
          content: '';
          display: inline-block;
          height: 4px;
          margin-bottom: 2px;
          margin-right: ${({ theme }) => theme.spacing.base.xs};
          width: 4px;
        }
      `;
    }

    return '';
  }}
`;

export const SubServiceInfoLabel = styled.span`
  margin-left: ${({ theme }) => theme.spacing.base.xxs};
`;

export const SubServicesInfoArrow = styled(Arrow)<ArrowProps>`
  margin: ${({ theme }) => `0 0 ${theme.spacing.mobile.xxs} ${theme.spacing.base.sm}`};
  opacity: 0.8;
`;
